import {
  GET_PAYMENT_LOADING,
  GET_PAYMENT_SUCCESS,
  GET_PAYMENT_FAILED,
  PAYMENT_RECORD_LOADING,
  PAYMENT_RECORD_FAILED,
  PAYMENT_RECORD_SUCCESS,
  PAYMENT_SAVE_LOADING,
  PAYMENT_SAVE_FAILED,
  PAYMENT_SAVE_SUCCESS,
} from "../Constants/paymentConstants";

export const paymentReducer = (
  state = { paymentData: [] },
  action
) => {
  switch (action.type) {
    case GET_PAYMENT_LOADING:
      return { loading: true, paymentData: [] };
    case GET_PAYMENT_SUCCESS:
      return { loading: false, paymentData: action.payload };
    case GET_PAYMENT_FAILED:
      return { loading: false, error: action.paymentData };
    default:
      return state;
  }
};

export const paymentRecordReducer = (
  state = { paymentRecordData: [] },
  action
) => {
  switch (action.type) {
    case PAYMENT_RECORD_LOADING:
      return { loading: true, paymentRecordData: [] };
    case PAYMENT_RECORD_SUCCESS:
      return { loading: false, paymentRecordData: action.payload };
    case PAYMENT_RECORD_FAILED:
      return { loading: false, error: action.paymentRecordData };
    default:
      return state;
  }
};

export const paymentSaveReducer = (
  state = { paymentSaveData: [] },
  action
) => {
  switch (action.type) {
    case PAYMENT_SAVE_LOADING:
      return { loadingData: true, paymentSaveData: [] };
    case PAYMENT_SAVE_SUCCESS:
      return { loadingData: false, paymentSaveData: action.payload };
    case PAYMENT_SAVE_FAILED:
      return { loadingData: false, error: action.paymentSaveData };
    default:
      return state;
  }
};
